import React, { useState, useEffect } from "react";
import { pathOr } from "ramda";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { user } from "../../_shared/auth";
import { useFeature } from "../../_shared/feature";

const Navlinks = ({
  setCollapsed,
  setHoverResources,
  setFadeClass,
  isMobile = false,
  handleMouseLeave,
  handleMouseEnter,
  openResourcesMobileSubNav,
  setOpenResourcesMobileSubNav,
}) => {
  const { t } = useTranslation();
  const orgchartUsers = useFeature("Orgchart Users");
  const location = useLocation();
  const navigate = useNavigate();
  const [blueHighlight, setBlueHighlight] = useState(false);
  const [visitedSubNav, setVisitedSubNav] = useState(false);

  useEffect(() => {
    if (openResourcesMobileSubNav) {
      setVisitedSubNav(true);
    }
    setOpenResourcesMobileSubNav(false);
  }, []);

  return (
    <>
      <li>
        <NavLink
          data-cy="navlink-root"
          style={{ textDecoration: "none" }}
          className={({ isActive }) =>
            isActive && !visitedSubNav
              ? "relative border-l-[5px] border-secondary bg-base-80 [border-left-style:solid] [&_a]:visited:text-white [&_span]:left-[-5px] [&_span]:text-white"
              : ""
          }
          onClick={() => {
            setCollapsed(true);
            document.title = "myApplied - Home";
          }}
          to="/"
        >
          <span className="relative">{t("Home")}</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          data-cy="navlink-dashboard"
          style={{ textDecoration: "none" }}
          className={({ isActive }) =>
            isActive
              ? "relative border-l-[5px] border-secondary bg-base-80 [border-left-style:solid] [&_a]:visited:text-white [&_span]:left-[-5px] [&_span]:text-white"
              : ""
          }
          onClick={() => {
            setCollapsed(true);
            document.title = "myApplied - Dashboard";
          }}
          to="/dashboard/home"
        >
          <span className="relative">{t("Dashboard")}</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          data-cy="navlink-announcements"
          style={{ textDecoration: "none" }}
          className={({ isActive }) =>
            isActive
              ? "relative border-l-[5px] border-secondary bg-base-80 [border-left-style:solid] [&_a]:visited:text-white [&_span]:left-[-5px] [&_span]:text-white"
              : ""
          }
          onClick={() => {
            document.title = "myApplied - Announcements";
            setCollapsed(true);
          }}
          to="/announcements"
        >
          <span className="relative">{t("Announcements")}</span>
        </NavLink>
      </li>
      {user?.isUS && (
        <li>
          <NavLink
            data-cy="navlink-apps"
            style={{ textDecoration: "none" }}
            className={({ isActive }) =>
              isActive
                ? "relative border-l-[5px] border-secondary bg-base-80 [border-left-style:solid] [&_a]:visited:text-white [&_span]:left-[-5px] [&_span]:text-white"
                : ""
            }
            onClick={() => {
              document.title = "myApplied - eCommerce";
              setCollapsed(true);
            }}
            to="/applied-shop/home"
          >
            <span className="relative">{t("Store")}</span>
          </NavLink>
        </li>
      )}
      <li>
        <NavLink
          data-cy="navlink-campusmap"
          style={{ textDecoration: "none" }}
          className={({ isActive }) =>
            isActive
              ? "relative border-l-[5px] border-secondary bg-base-80 [border-left-style:solid] [&_a]:visited:text-white [&_span]:left-[-5px] [&_span]:text-white"
              : ""
          }
          onClick={() => {
            document.title = "myApplied - Campus Maps";
            setCollapsed(true);
          }}
          to="/campusmap/rsm"
        >
          <span className="relative">{t("Campus Map")}</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          data-cy="navlink-directory"
          style={{ textDecoration: "none" }}
          className={({ isActive }) =>
            isActive
              ? "relative border-l-[5px] border-secondary bg-base-80 [border-left-style:solid] [&_a]:visited:text-white [&_span]:left-[-5px] [&_span]:text-white"
              : ""
          }
          onClick={() => {
            document.title = "myApplied - Directory";
            setCollapsed(true);
          }}
          to="/directory"
        >
          <span className="relative">{t("Directory")}</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          data-cy="navlink-discounts"
          style={{ textDecoration: "none" }}
          className={({ isActive }) =>
            isActive
              ? "relative border-l-[5px] border-secondary bg-base-80 [border-left-style:solid] [&_a]:visited:text-white [&_span]:left-[-5px] [&_span]:text-white"
              : ""
          }
          onClick={() => {
            document.title = "myApplied - Discounts";
            setCollapsed(true);
          }}
          to="/discounts/restaurant"
        >
          <span className="relative">{t("Discounts")}</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          data-cy="navlink-events"
          style={{ textDecoration: "none" }}
          className={({ isActive }) =>
            isActive
              ? "relative border-l-[5px] border-secondary bg-base-80 [border-left-style:solid] [&_a]:visited:text-white [&_span]:left-[-5px] [&_span]:text-white"
              : ""
          }
          onClick={() => {
            document.title = "myApplied - Calendar";
            setCollapsed(true);
          }}
          to="/events"
        >
          <span className="relative">{t("Events")}</span>
        </NavLink>
      </li>
      {(!pathOr(true, ["isSales"], user) || orgchartUsers) && (
        <li>
          <NavLink
            data-cy="navlink-orgchart"
            style={{ textDecoration: "none" }}
            className={({ isActive }) =>
              isActive
                ? "relative border-l-[5px] border-secondary bg-base-80 [border-left-style:solid] [&_a]:visited:text-white [&_span]:left-[-5px] [&_span]:text-white"
                : ""
            }
            onClick={() => {
              document.title = "myApplied - Organizational Chart";
              setCollapsed(true);
            }}
            to={`/orgchart/${user.TeamId}`}
          >
            <span className="relative">{t("Org Chart")}</span>
          </NavLink>
        </li>
      )}
      <li>
        <NavLink
          data-cy="navlink-portals"
          style={{ textDecoration: "none" }}
          className={({ isActive }) =>
            isActive
              ? "relative border-l-[5px] border-secondary bg-base-80 [border-left-style:solid] [&_a]:visited:text-white [&_span]:left-[-5px] [&_span]:text-white"
              : ""
          }
          onClick={() => {
            document.title = "myApplied - Portals";
            setCollapsed(true);
          }}
          to="/portals/"
        >
          <span className="relative">{t("Portals")}</span>
        </NavLink>
      </li>
      <li
        data-cy="navlink-resources"
        style={{ textDecoration: "none" }}
        className={`relative box-border py-2 pr-0 ${
          isMobile ? "text-white" : ""
        } ${
          location.pathname.startsWith("/resources") || visitedSubNav
            ? "border-l-[5px] border-secondary bg-base-80 pl-5 [border-left-style:solid]"
            : "pl-6 text-gray-shades-80 hover:text-white"
        }`}
        onMouseEnter={handleMouseEnter}
        onClick={(e) => {
          if (isMobile) {
            setCollapsed(true);
            setOpenResourcesMobileSubNav(true);
          }
        }}
        onMouseLeave={handleMouseLeave}
      >
        <span className="relative">{t("Resources")}</span>
      </li>
      <li>
        <NavLink
          data-cy="training-tree"
          style={{ textDecoration: "none" }}
          className={({ isActive }) =>
            isActive
              ? "relative border-l-[5px] border-secondary bg-base-80 [border-left-style:solid] [&_a]:visited:text-white [&_span]:left-[-5px] [&_span]:text-white"
              : ""
          }
          onClick={() => {
            document.title = "myApplied - Training Tree";
            setCollapsed(true);
          }}
          to="/training-tree/1"
        >
          <span className="relative">{t("Training Tree")}</span>
        </NavLink>
      </li>
    </>
  );
};

export default Navlinks;
